import React, { useState, useEffect, useRef } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { primarycolor } from '../Utils/colors';
import ReactLoading from 'react-loading';
import axios from "axios";
import { setsessionuser } from '../Utils/sessions';
import { Registerurl, Validateregistercodeurl } from '../Utils/urls';
import { Autocomplete, Container, Modal } from '@mui/material';
import { allcampuses } from '../Utils/arrays';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import { AccountCircle, Google, School } from '@mui/icons-material';
import ReactCodeInput from 'react-verification-code-input';

let color = "white";
let type = "spokes";


export default function SignUp({ successsignup, cancelsignup }) {
    const googlebuttonref = useRef()
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const [progress, setprogress] = useState(false);
    const [showregister, setshowregister] = useState(true);
    const [showchoosetype, setshowchoosetype] = useState(true);

    const [userInfo, setUserInfo] = useState([]);
    const [useremail, setuseremail] = useState('');

    const [usertype, setusertype] = useState('');
    const [code, setcode] = useState(0);


    useEffect(
        () => {
            if (userInfo) {
                axios
                    .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${userInfo.access_token}`, {
                        headers: {
                            Authorization: `Bearer ${userInfo.access_token}`,
                            Accept: 'application/json'
                        }
                    })
                    .then((response) => {
                        handlegooglesignup(response.data.email, response.data.name, response.data.picture)
                    })
                    .catch((error) => console.log(error));
            }
        },
        [userInfo]
    )


    const handleSubmit = (event) => {
        setprogress(true)
        seterror(null)
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const email = data.get('email')
        const password = data.get('password')
        const firstName = data.get('firstName')
        const lastName = data.get('lastName')
        const phone = data.get('phone');
        const campus = data.get("campus");
       
        if (!email || !password || !firstName || !lastName || !phone) {
            seterror("Fill all fields")
            setprogress(false)
        } else {
            seterror(null)
            axios.post(Registerurl, {
                username: firstName + " " + lastName,
                email: email,
                phone: phone,
                password: password,
                campus: campus,
                verified: false,
                profile_url: ''
            }).then(response => {
                setprogress(false)
                if (!response.data.error) {
                    setuseremail(email)
                    setshowregister(false)
                } else {
                    seterror(response.data.message)
                }
            }).catch(error => {
                setprogress(false)
                seterror("Sorry an error occurred,try again later");
            });
        }
    };

    //handle google sign up
    const handlegooglesignup = (email, username, profile_url) => {
        setprogress(true)
        seterror(null)
        axios.post(Registerurl, {
            username: username,
            email: email,
            phone: email,
            password: email,
            campus: "All",
            profile_url: profile_url,
            verified: true
        }).then(response => {
            setprogress(false)
            if (!response.data.message) {
                if (response.data.success) {
                    setsessionuser(response.data)
                    successsignup()
                } else {
                    seterror("there was an internal error contact admin")
                }
            } else {
                seterror(response.data.message)
            }
        }).catch(error => {
            setprogress(false)
            seterror("Sorry an error occurred,try again later");
        });
    }

    const login = useGoogleLogin({
        onSuccess: (response) => setUserInfo(response),
        onError: (error) => console.log(`Login Failed: ${error}`,)
    });

    const choosetype = (type) => {
        setusertype(type)
        setshowchoosetype(false)
        if (type !== "student") {
            googlebuttonref.current.click();
        }
    }

    //verify code
    const validatecode = (event) => {
        setprogress(true)
        seterror(null)
        event.preventDefault()
        axios.post(Validateregistercodeurl, {
            email: useremail,
            code: code
        }).then(response => {
            setprogress(false)
            if (!response.data.error) {
                setsuccess('code validated sucessfully,redirecting,,,,')
                setTimeout(() => {
                    cancelsignup()
                }, 3000);
            } else {
                seterror(response.data.message)
            }
        }).catch(error => {
            setprogress(false)
            seterror("Sorry an error occurred,try again later");
        });
    }


    return (
        <Box
            sx={{
                marginTop: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Modal
                open={showchoosetype}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Container component="main" maxWidth="xs" style={{ backgroundColor: "white", borderRadius: 20 }}>

                    <div style={{ marginTop: 10 }}><br />
                        <Typography>Choose Account Type:</Typography><br />
                        <Button onClick={() => choosetype("student")} variant='contained' fullWidth startIcon={<School />}>Student</Button><br /><br />
                        <Button onClick={() => choosetype("non-student")} variant='outlined' fullWidth startIcon={<AccountCircle />}>Non-Student</Button>
                    </div>
                    <br />

                </Container>
            </Modal>
            <Avatar sx={{ m: 1, bgcolor: primarycolor }}>
                <LockOutlinedIcon />
            </Avatar>
            {showregister &&
                <Typography component="h1" variant="h5">
                    Sign up
                </Typography>
            }
            <div className='overflowdivwithoutscroll' >
                {!showregister &&
                    <div style={{ marginTop: 30 }}><br /><br />
                        <div >Enter Code sent to {useremail}</div>
                        <Box component="form" onSubmit={validatecode} noValidate sx={{
                            marginTop: 8,
                        }}>
                            <ReactCodeInput
                                onChange={setcode}
                            />
                            {success && <div style={{ color: "green", fontSize: 10 }}>{success}</div>}
                            {error && <div style={{ color: "red", fontSize: 10 }}>{error}</div>}
                            <Button
                                type="submit"
                                fullWidth
                                style={{ backgroundColor: primarycolor }}
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Validate Code"}
                            </Button>
                        </Box>
                    </div>
                }
                {showregister &&
                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    autoComplete="given-name"
                                    name="firstName"
                                    required
                                    fullWidth
                                    id="firstName"
                                    label="First Name"
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="lastName"
                                    label="Last Name"
                                    name="lastName"
                                    autoComplete="family-name"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    autoComplete="email"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    id="phone"
                                    label="Phone number"
                                    name="phone"
                                    autoComplete="tel"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="new-password"
                                />
                            </Grid>
                            {usertype === "student" &&
                                <Grid item xs={12}>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={allcampuses}
                                        fullWidth
                                        renderInput={(params) => <TextField required name="campus" id="campus" {...params} label="Campus" />}
                                    />
                                </Grid>}
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox value="allowExtraEmails" color="primary" />}
                                    label="Remember me."
                                />
                            </Grid>
                        </Grid>
                        {error && <div style={{ fontSize: 10, color: "red" }}>{error}</div>}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Sign Up"}
                        </Button>
                        <Grid container justifyContent="flex-end">
                            <Grid item>
                                <Link to="" onClick={() => cancelsignup()} style={{ color: primarycolor, fontSize: 13 }} variant="body2">
                                    Already have an account? Sign in
                                </Link>
                            </Grid>
                        </Grid>
                        {usertype !== "student" &&
                            <p align="middle">
                                <Button variant='outlined' ref={googlebuttonref} onClick={() => login()} startIcon={<Google />}>Continue with Google</Button>
                            </p>
                        }
                    </Box>}
            </div>
        </Box>
    );
}